import { useTranslation } from 'react-i18next';
import {
  MAX_PROMPT_LEN,
  MIN_PROMPT_LEN,
  PROMPT_SUGGESTION_KEYS,
} from '../../data/promptSuggestions';

type PromptStepProps = {
  value: string;
  onChange: (v: string) => void;
  onNext: () => void;
  onBack: () => void;
};

export function PromptStep({ value, onChange, onNext, onBack }: PromptStepProps) {
  const { t } = useTranslation();
  const trimmedLen = value.trim().length;
  const canContinue = trimmedLen >= MIN_PROMPT_LEN;

  return (
    <div className="wizard-step" data-step="prompt">
      <h2 className="wizard-step__title">{t('wizard.promptTitle')}</h2>
      <p className="wizard-step__hint">{t('wizard.promptHint')}</p>

      <textarea
        className="prompt-textarea"
        placeholder={t('wizard.promptPlaceholder')}
        minLength={MIN_PROMPT_LEN}
        maxLength={MAX_PROMPT_LEN}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />

      <div className="prompt-suggestions">
        {PROMPT_SUGGESTION_KEYS.map((key) => {
          const suggestion = t(key);
          return (
            <button
              key={key}
              type="button"
              className="suggestion-chip"
              onClick={() => onChange(suggestion)}
            >
              {suggestion}
            </button>
          );
        })}
      </div>

      <div className="wizard-footer">
        <button type="button" className="btn btn--ghost" onClick={onBack}>
          {t('common.back')}
        </button>
        <button
          type="button"
          className="btn btn--primary"
          disabled={!canContinue}
          onClick={onNext}
        >
          {t('common.next')}
        </button>
      </div>
    </div>
  );
}
